import Swiper from "swiper";
let map;
let infowindow;
let markerIcon;
let markerIconJL;
let markers = [];

let storeLocationsJl = window.storeLocationsJl || [];
let storeLocations = window.storeLocations || [];

/**
 * An location object
 * @typedef {{lat: number, lng: number}} Location
 */

/**
 * An store object
 * @typedef {{title: string, adress: string, zip: string, city: string, phone: string, lat: number, lng: number, distance: number}} Store
 */

/**
 * Init google maps
 */
function initMap() {
  map = new google.maps.Map(document.getElementById("map"), {
    center: { lat: 52.519325, lng: 13.392709 },
    zoom: 4,
    // maxZoom: 14,
    mapId: "5ca733807525aa5c",
    disableDefaultUI: true,
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
  });

  var input = document.getElementById("map-searchbox");
  var autocomplete = new google.maps.places.Autocomplete(input);

  markerIconJL = {
    url: markerUrlJL,
    scaledSize: new google.maps.Size(48, 58),
  };
  markerIcon = {
    url: markerUrl,
    scaledSize: new google.maps.Size(48, 58),
  };

  const addMarker = (place, index, isJlMarker = false) => {
    const marker = new google.maps.Marker({
      map: map,
      icon: isJlMarker ? markerIconJL : markerIcon,
      position: { lat: place.lat, lng: place.lng },
      title: place.title,
      index: index,
    });

    marker.addListener("click", function () {
      displayStoreInfo(index, isJlMarker);
    });

    markers.push(marker);

    createStore(place, index, isJlMarker);
  };

  if (window.storeLocations) {
    storeLocations.forEach(
      (place, index) => place.lat && place.lng && addMarker(place, index, false)
    );
  }
  if (window.storeLocationsJl) {
    storeLocationsJl.forEach(
      (place, index) => place.lat && place.lng && addMarker(place, index, true)
    );
  }

  const renderer = {
    render: ({ count, position }) => {
      const svg = window.btoa(`
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <circle cx="24" cy="24" r="24" fill="#fff" fill-opacity=".35" />
        <circle cx="24" cy="24" r="23.5" stroke="#000" stroke-opacity=".15" />
        <rect x="12" y="12" width="24" height="24" fill="#fff" rx="12" />
      </svg>`);
      return new google.maps.Marker({
        position,
        icon: {
          url: `data:image/svg+xml;base64,${svg}`,
          scaledSize: new google.maps.Size(48, 48),
        },
        label: {
          text: String(count),
          color: "rgba(0,0,0,1)",
          fontFamily: "Suisse Intl",
          fontSize: "10px",
          fontWeight: "600",
        },
        title: `Cluster of ${count} markers`,
        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
      });
    },
  };

  new markerClusterer.MarkerClusterer({ markers, map, renderer });

  autocomplete.bindTo("bounds", map);
  autocomplete.setFields(["address_components", "geometry", "name"]);

  // Listen for the event fired when the user selects a prediction and retrieve
  // more details for that place.
  autocomplete.addListener("place_changed", function () {
    var place = autocomplete.getPlace();

    if (!place.geometry) {
      console.log("Returned place contains no geometry");
      return;
    }
    var bounds = new google.maps.LatLngBounds();
    // marker.setPosition(place.geometry.location);

    if (place.geometry.viewport) {
      bounds.union(place.geometry.viewport);
    } else {
      bounds.extend(place.geometry.location);
    }

    const lat = place.geometry.location.lat(),
      lng = place.geometry.location.lng();

    // sort list
    sortStores(lat, lng);

    // fitBounds to 3 closest markers to location
    var closest = findClosestLocations(place.geometry.location, 3);
    for (let i = 0; i < closest.length; i++) {
      bounds.extend(closest[i].position);
    }
    map.fitBounds(bounds);
  });

  window.addEventListener("geoLocationUpdated", handleGeoLocation);
}

/**
 *
 * @param {Location} from
 * @param {number} numberOfResults
 * @returns Location[]
 */
function findClosestLocations(from, numberOfResults = 3) {
  var closest = [];
  for (var i = 0; i < markers.length; i++) {
    markers[i].distance = google.maps.geometry.spherical.computeDistanceBetween(
      from,
      markers[i].getPosition()
    );
    closest.push(markers[i]);
  }
  closest.sort((a, b) => a.distance - b.distance);
  return closest.splice(0, numberOfResults);
}

/**
 * Appends store HTML to #stores
 * @param {Store} place - Store object
 */
function createStore(place, index, isJlMarker) {
  const content = document.createElement("div");

  content.addEventListener("click", () => {
    displayStoreInfo(index, isJlMarker);
  });

  content.classList.add("store", "cursor-pointer");
  content.dataset.lat = place.lat;
  content.dataset.lng = place.lng;
  content.dataset.index = index;
  content.classList.add(
    "store",
    "border-t",
    "border-solid",
    "border-black-15",
    "grid",
    "grid-cols-12",
    "pt-8",
    "pb-48",
    "lg:pt-12"
  );

  const divLeft = document.createElement("div");
  divLeft.classList.add("uppercase", "col-span-6", "pr-12");
  divLeft.innerHTML = place.title;
  content.appendChild(divLeft);

  const divRight = document.createElement("div");
  divRight.classList.add("col-span-6");
  content.appendChild(divRight);

  const address = document.createElement("p");
  address.innerHTML = place.address + "<br />" + place.zip + " " + place.city;
  divRight.appendChild(address);

  divRight.innerHTML +=
    '<a href="#" class="btn mt-12" data-scroll-label="More information"><span>More information</span></a>';

  stores.appendChild(content);
}

function fitBoundsToMarkers(markers) {
  var bounds = new google.maps.LatLngBounds();
  for (let i = 0; i < markers.length; i++) {
    bounds.extend(markers[i].position);
  }
  map.fitBounds(bounds);
}

function handleGeoLocation(event) {
  const geoLocation = event.detail.message;
  if (geoLocation && geoLocation.coords) {
    const location = {
      lat: geoLocation.coords.latitude,
      lng: geoLocation.coords.longitude,
    };
    var closest = findClosestLocations(location, 3);
    // closest.unshift(location);
    fitBoundsToMarkers(closest);
    sortStores(location.lat, location.lng);
  }
}

function hideStoreList() {
  const storeList = document.getElementById("storeList");
  storeList.style.display = "none";
}

function toggleStoreList() {
  const storeList = document.getElementById("storeList");
  if (storeList.getAttribute("style")) {
    storeList.style.display = "";
  } else {
    storeList.style.display = "none";
  }
}

function displayStoreInfo(index, jl) {
  const container = document.getElementById("storeInfo");
  const template = document.getElementById("storeTemplate");

  const storeData = jl ? storeLocationsJl[index] : storeLocations[index];
  if (storeData) {
    const store = template.content.firstElementChild.cloneNode(true);

    const replaceText = (attribute, content) => {
      store.innerHTML = store.innerHTML.replaceAll(
        "||" + attribute + "||",
        content
      );
    };

    const deleteNode = (attribute) => {
      const node = store.querySelector("." + attribute);
      if (node) {
        node.parentNode.removeChild(node);
      }
    };

    const store_data_attributes = [
      "address",
      "title",
      "zip",
      "city",
      "country",
      "phone",
      "open_mon_sun",
      "open_mon_fri",
      "open_mon_thurs",
      "open_monday",
      "open_tuesday",
      "open_wednesday",
      "open_thursday",
      "open_friday",
      "open_saturday",
      "open_sunday",
      "lat",
      "lng",
    ];

    store_data_attributes.forEach((attribute) => {
      if (storeData[attribute]) {
        const isStore =
          Array.isArray(storeData["types"]) &&
          storeData["types"].indexOf("store") !== -1;
        if (
          attribute === "title" &&
          !isStore &&
          storeData["rawData"] &&
          storeData["rawData"]["title"]
        ) {
          replaceText(attribute, storeData["rawData"]["title"]);
        } else {
          replaceText(attribute, storeData[attribute]);
        }
      } else {
        deleteNode(attribute);
      }
    });

    // Object.keys(storeData)
    //   .filter((attribute) => attribute.indexOf("open_") === -1)
    //   .forEach((attribute) => {
    //     if (storeData[attribute]) {
    //       replaceText(attribute);
    //     } else {
    //       deleteNode(attribute);
    //     }
    //   });

    let swiper;
    if (storeData.images && storeData.images.length) {
      const swiperWrapper = store.querySelector(".swiper-wrapper");
      storeData.images.forEach((image) => {
        const imgWrapper = document.createElement("div");
        imgWrapper.className = "swiper-slide";
        const img = document.createElement("img");
        img.src = image;
        img.className = "object-cover object-center w-full h-full";
        img.loading = "lazy";
        imgWrapper.appendChild(img);
        swiperWrapper.appendChild(imgWrapper);
      });
      swiper = new Swiper(store.querySelector(".swiper"), {
        preloadImages: false,
        loop: true,
      });
      const prevButton = store.querySelector(".swiper-prev");
      prevButton.addEventListener("click", () => swiper.slidePrev());
      const nextButton = store.querySelector(".swiper-next");
      nextButton.addEventListener("click", () => swiper.slideNext());
    } else {
      store.querySelector("#storeSlider").style.display = "none";
    }

    const buttons = store.querySelectorAll("button.close");

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        toggleStoreList(index);
        if (swiper) swiper.destroy();
        container.innerHTML = "";
      });
    });

    container.innerHTML = "";
    container.appendChild(store);
    hideStoreList();
  }
}

const getDistance = (x1, x2, y1, y2) => {
  let y = x2 - x1;
  let x = y2 - y1;

  return Math.sqrt(x * x + y * y);
};

// Function to sort Data
function sortStores(lat, lng) {
  // add distance from marker to location
  const stores = document.querySelectorAll(".store");
  stores.forEach((store) => {
    store.dataset.distance = getDistance(
      store.dataset.lat,
      lat,
      store.dataset.lng,
      lng
    );
  });

  var subjectsArray = Array.from(stores);

  let sorted = subjectsArray.sort((divA, divB) => {
    const a = parseFloat(divA.dataset.distance);
    const b = parseFloat(divB.dataset.distance);
    return a - b;
  });

  stores.innerHTML = "";
  sorted.forEach((e) => document.querySelector("#stores").appendChild(e));
  return sorted;
}

window.initMap = initMap;
